// userReducer.js
import equipmentImage from "../assets/js/equipmentImage";
import canvasEquipmentImage from "../assets/js/canvasEquipmentImage";

// zIndex
// cloaks: 1
// bear: 2
// face: 3
// 其餘都先放4

const initialState = {
  userName: null,
  initData: null,
  statusData: null,
  loading: false,
  error: null,
  bearSetInfo: [
    // Weapon
    {
      categoryId: 1,
      title: { zh: "武器", en: "Weapon", jp: "武器", cn: "武器" },
      equipment: [
        // 總共9個
        {
          id: 1,
          name: { zh: "溜溜球", en: "Yo-yo", jp: "ヨーヨー", cn: "溜溜球" },
          imageInfo: [
            {
              src: canvasEquipmentImage.weapons01,
              listSrc: equipmentImage.weapons01,
              width: 190,
              height: 284,
              x: 678,
              y: 547,
              zIndex: 4,
            },
          ],
        },
        {
          id: 2,
          name: {
            zh: "魔法杖",
            en: "Magic Wand",
            jp: "魔法の杖",
            cn: "魔法杖",
          },
          imageInfo: [
            {
              src: canvasEquipmentImage.weapons02,
              listSrc: equipmentImage.weapons02,
              width: 370,
              height: 370,
              x: 622,
              y: 285,
              zIndex: 4,
            },
          ],
        },
        {
          id: 3,
          name: { zh: "鴨鴨", en: "Duck", jp: "アヒル", cn: "鸭鸭" },
          imageInfo: [
            {
              src: canvasEquipmentImage.weapons03,
              listSrc: equipmentImage.weapons03,
              width: 258,
              height: 258,
              x: 626,
              y: 400,
              zIndex: 4,
            },
          ],
        },
        {
          id: 4,
          name: { zh: "拖鞋", en: "Slippers", jp: "スリッパ", cn: "拖鞋" },
          imageInfo: [
            {
              src: canvasEquipmentImage.weapons04,
              listSrc: equipmentImage.weapons04,
              width: 256,
              height: 274,
              x: 637,
              y: 375,
              zIndex: 4,
            },
          ],
        },
        {
          id: 5,
          name: { zh: "捕蟲網", en: "Bug Net", jp: "虫取り網", cn: "捕虫网" },
          imageInfo: [
            {
              src: canvasEquipmentImage.weapons05,
              listSrc: equipmentImage.weapons05,
              width: 313,
              height: 323,
              x: 630,
              y: 290,
              zIndex: 4,
            },
          ],
        },
        {
          id: 6,
          name: {
            zh: "智慧槌",
            en: "Smart Hammer",
            jp: "知恵のハンマー",
            cn: "智慧槌",
          },
          imageInfo: [
            {
              src: canvasEquipmentImage.weapons06,
              listSrc: equipmentImage.weapons06,
              width: 256,
              height: 256,
              x: 657,
              y: 377,
              zIndex: 4,
            },
          ],
        },
        {
          id: 7,
          name: { zh: "噴射槍", en: "Jet Gun", jp: "スプレー銃", cn: "喷射枪" },
          imageInfo: [
            {
              src: canvasEquipmentImage.weapons07,
              listSrc: equipmentImage.weapons07,
              width: 220,
              height: 191,
              x: 643,
              y: 426,
              zIndex: 4,
            },
          ],
        },
        {
          id: 8,
          name: { zh: "花花", en: "Flowers", jp: "はな", cn: "花花" },
          imageInfo: [
            {
              src: canvasEquipmentImage.weapons08,
              listSrc: equipmentImage.weapons08,
              width: 270,
              height: 270,
              x: 660,
              y: 362,
              zIndex: 4,
            },
          ],
        },
        {
          id: 9,
          name: {
            zh: "光劍",
            en: "Light Saber",
            jp: "ライトソード",
            cn: "光剑",
          },
          imageInfo: [
            {
              src: canvasEquipmentImage.weapons09,
              listSrc: equipmentImage.weapons09,
              width: 400,
              height: 400,
              x: 626,
              y: 264,
              zIndex: 4,
            },
          ],
        },
        {
          id: 10,
          name: {
            zh: "矽晶盾",
            en: "Silicon Wafer Shield",
            jp: "シリコンシールド",
            cn: "矽晶盾",
          },
          imageInfo: [
            {
              src: canvasEquipmentImage.weapons10,
              listSrc: equipmentImage.weapons10,
              width: 403,
              height: 403,
              x: 572,
              y: 476,
              zIndex: 4,
            },
          ],
        },
      ],
    },
    // Headwear
    {
      categoryId: 2,
      title: { zh: "頭飾", en: "Headwear", jp: "被り物", cn: "头饰" },
      equipment: [
        // 總共9個
        {
          id: 1,
          name: {
            zh: "竹蜻蜓",
            en: "Bamboo Dragonfly",
            jp: "竹とんぼ",
            cn: "竹蜻蜓",
          },
          imageInfo: [
            {
              src: canvasEquipmentImage.headgears01,
              listSrc: equipmentImage.headgears01,
              width: 181,
              height: 130,
              x: 885,
              y: 351,
              zIndex: 4,
            },
          ],
        },
        {
          id: 2,
          name: {
            zh: "酷酷眼鏡",
            en: "Cool Glasses",
            jp: "クールメガネ",
            cn: "酷酷眼镜",
          },
          imageInfo: [
            {
              src: canvasEquipmentImage.headgears02,
              listSrc: equipmentImage.headgears02,
              width: 209,
              height: 209,
              x: 866,
              y: 383,
              zIndex: 4,
            },
          ],
        },
        {
          id: 3,
          name: {
            zh: "潛水鏡",
            en: "Diving Glasses",
            jp: "潜水メガネ",
            cn: "潜水镜",
          },
          imageInfo: [
            {
              src: canvasEquipmentImage.headgears03,
              listSrc: equipmentImage.headgears03,
              width: 345,
              height: 345,
              x: 803,
              y: 272,
              zIndex: 4,
            },
          ],
        },
        {
          id: 4,
          name: {
            zh: "怪獸帽",
            en: "Monster Hat",
            jp: "怪獣キャップ",
            cn: "怪兽帽",
          },
          imageInfo: [
            {
              src: canvasEquipmentImage.headgears04,
              listSrc: equipmentImage.headgears04,
              width: 336,
              height: 336,
              x: 790,
              y: 285,
              zIndex: 4,
            },
          ],
        },
        {
          id: 5,
          name: {
            zh: "探險帽",
            en: "Explorer Hat",
            jp: "探検帽子",
            cn: "探险帽",
          },
          imageInfo: [
            {
              src: canvasEquipmentImage.headgears05,
              listSrc: equipmentImage.headgears05,
              width: 297,
              height: 297,
              x: 828,
              y: 310,
              zIndex: 4,
            },
          ],
        },
        {
          id: 6,
          name: {
            zh: "運動帽",
            en: "Sports Cap",
            jp: "スポーツキャップ",
            cn: "运动帽",
          },
          imageInfo: [
            {
              src: canvasEquipmentImage.headgears06,
              listSrc: equipmentImage.headgears06,
              width: 260,
              height: 260,
              x: 843,
              y: 337,
              zIndex: 4,
            },
          ],
        },
        {
          id: 7,
          name: {
            zh: "機師帽",
            en: "Aviator Hat",
            jp: "パイロット帽",
            cn: "机师帽",
          },
          imageInfo: [
            {
              src: canvasEquipmentImage.headgears07,
              listSrc: equipmentImage.headgears07,
              width: 472,
              height: 472,
              x: 737,
              y: 309,
              zIndex: 4,
            },
          ],
        },
        {
          id: 8,
          name: {
            zh: "牛仔帽",
            en: "Cowboy Hat",
            jp: "カウボーイハット",
            cn: "牛仔帽",
          },
          imageInfo: [
            {
              src: canvasEquipmentImage.headgears08,
              listSrc: equipmentImage.headgears08,
              width: 390,
              height: 390,
              x: 780,
              y: 269,
              zIndex: 4,
            },
          ],
        },
        {
          id: 9,
          name: {
            zh: "太空盔",
            en: "Space Helmet",
            jp: "宇宙飛行士ヘルメット",
            cn: "太空盔",
          },
          imageInfo: [
            {
              src: canvasEquipmentImage.headgears09,
              listSrc: equipmentImage.headgears09,
              width: 345,
              height: 345,
              x: 803,
              y: 400,
              zIndex: 4,
            },
          ],
        },
      ],
    },
    // Face
    {
      categoryId: 3,
      title: { zh: "表情", en: "Face", jp: "顔", cn: "表情" },
      equipment: [
        // 總共6個
        {
          id: 1,
          name: { zh: "耶咿", en: "Yah!", jp: "イェーイ", cn: "耶咿" },
          imageInfo: [
            {
              src: canvasEquipmentImage.face01,
              listSrc: equipmentImage.face01,
              width: 142,
              height: 142,
              x: 905,
              y: 491,
              zIndex: 4,
            },
          ],
        },
        {
          id: 2,
          name: { zh: "愛了", en: "Love it!", jp: "好き", cn: "爱了" },
          imageInfo: [
            {
              src: canvasEquipmentImage.face02,
              listSrc: equipmentImage.face02,
              width: 142,
              height: 142,
              x: 905,
              y: 491,
              zIndex: 4,
            },
          ],
        },
        {
          id: 3,
          name: { zh: "酷喔", en: "That's so cool!", jp: "クール", cn: "酷喔" },
          imageInfo: [
            {
              src: canvasEquipmentImage.face03,
              listSrc: equipmentImage.face03,
              width: 142,
              height: 142,
              x: 905,
              y: 491,
              zIndex: 4,
            },
          ],
        },
        {
          id: 4,
          name: { zh: "亮晶晶", en: "Shiny", jp: "キラキラ", cn: "亮晶晶" },
          imageInfo: [
            {
              src: canvasEquipmentImage.face04,
              listSrc: equipmentImage.face04,
              width: 142,
              height: 142,
              x: 905,
              y: 491,
              zIndex: 4,
            },
          ],
        },
        {
          id: 5,
          name: { zh: "好耶", en: "Great!", jp: "ヤッホー", cn: "好耶" },
          imageInfo: [
            {
              src: canvasEquipmentImage.face05,
              listSrc: equipmentImage.face05,
              width: 142,
              height: 142,
              x: 905,
              y: 491,
              zIndex: 4,
            },
          ],
        },
        {
          id: 6,
          name: {
            zh: "氣噗噗",
            en: "Huffy-puffy",
            jp: "プンプン",
            cn: "气噗噗",
          },
          imageInfo: [
            {
              src: canvasEquipmentImage.face06,
              listSrc: equipmentImage.face06,
              width: 142,
              height: 142,
              x: 905,
              y: 491,
              zIndex: 4,
            },
          ],
        },
      ],
    },
    // Cloaks
    {
      categoryId: 4,
      title: { zh: "配件", en: "Accessories", jp: "アクセサリー", cn: "配件" },
      equipment: [
        // 總共6個
        {
          id: 1,
          name: {
            zh: "夢幻氣球",
            en: "Dreamy Balloon",
            jp: "ファンタジー風船",
            cn: "梦幻气球",
          },
          imageInfo: [
            {
              src: canvasEquipmentImage.cloaks01,
              listSrc: equipmentImage.cloaks01,
              width: 654,
              height: 654,
              x: 774,
              y: 202,
              zIndex: 1,
            },
          ],
        },
        {
          id: 2,
          name: {
            zh: "蝙蝠俠",
            en: "Batman",
            jp: "スパイダーマン",
            cn: "蝙蝠侠",
          },
          imageInfo: [
            {
              src: canvasEquipmentImage.cloaks02,
              listSrc: equipmentImage.cloaks02,
              width: 662,
              height: 662,
              x: 643,
              y: 441,
              zIndex: 1,
            },
          ],
        },
        {
          id: 3,
          name: {
            zh: "超人披風",
            en: "Superman Cape",
            jp: "スーパーマンのマント",
            cn: "超人披风",
          },
          imageInfo: [
            {
              src: canvasEquipmentImage.cloaks03,
              listSrc: equipmentImage.cloaks03,
              width: 682,
              height: 682,
              x: 634,
              y: 413,
              zIndex: 1,
            },
            {
              src: canvasEquipmentImage.cloaks03_1,
              listSrc: equipmentImage.cloaks03_1,
              width: 682,
              height: 682,
              x: 634,
              y: 413,
              zIndex: 3,
            },
          ],
        },
        {
          id: 4,
          name: {
            zh: "飛行器",
            en: "Flying Vehicle",
            jp: "飛翔体",
            cn: "飞行器",
          },
          imageInfo: [
            {
              src: canvasEquipmentImage.cloaks04,
              listSrc: equipmentImage.cloaks04,
              width: 800,
              height: 540,
              x: 574,
              y: 476,
              zIndex: 1,
            },
          ],
        },
        {
          id: 5,
          name: {
            zh: "潛水氣瓶",
            en: "cloaks 5",
            jp: "潛水氣瓶",
            cn: "潜水气瓶",
          },
          imageInfo: [
            {
              src: canvasEquipmentImage.cloaks05,
              listSrc: equipmentImage.cloaks05,
              width: 685,
              height: 423,
              x: 628,
              y: 522,
              zIndex: 1,
            },
          ],
        },
        {
          id: 6,
          name: {
            zh: "無塵衣",
            en: "Cleanroom Suit",
            jp: "クリーンウエア",
            cn: "无尘衣",
          },
          imageInfo: [
            {
              src: canvasEquipmentImage.cloaks06,
              listSrc: equipmentImage.cloaks06,
              width: 524,
              height: 524,
              x: 698,
              y: 471,
              zIndex: 3,
            },
          ],
        },
      ],
    },
    // wafers
    {
      categoryId: 5,
      title: { zh: "矽晶圓", en: "Wafers", jp: "ウェハー", cn: "矽晶圆" },
      equipment: [
        // 總共6個
        {
          id: 1,
          name: { zh: "神秘紫", en: "Mystery Purple", jp: "紫", cn: "神秘紫" },
          imageInfo: [
            {
              src: canvasEquipmentImage.wafers01,
              listSrc: equipmentImage.wafers01,
              width: 123,
              height: 139,
              x: 1073,
              y: 661,
              zIndex: 4,
            },
          ],
        },
        {
          id: 2,
          name: { zh: "科技藍", en: "Tech Blue", jp: "紺", cn: "科技蓝" },
          imageInfo: [
            {
              src: canvasEquipmentImage.wafers02,
              listSrc: equipmentImage.wafers02,
              width: 124,
              height: 124,
              x: 1076,
              y: 670,
              zIndex: 4,
            },
          ],
        },
        {
          id: 3,
          name: { zh: "元氣黃", en: "Vibrant Yellow", jp: "黄", cn: "元气黄" },
          imageInfo: [
            {
              src: canvasEquipmentImage.wafers03,
              listSrc: equipmentImage.wafers03,
              width: 95,
              height: 99,
              x: 1092,
              y: 680,
              zIndex: 4,
            },
          ],
        },
        {
          id: 4,
          name: { zh: "未來青", en: "Future Green", jp: "青", cn: "未来青" },
          imageInfo: [
            {
              src: canvasEquipmentImage.wafers04,
              listSrc: equipmentImage.wafers04,
              width: 134,
              height: 135,
              x: 1075,
              y: 663,
              zIndex: 4,
            },
          ],
        },
        {
          id: 5,
          name: {
            zh: "氣質粉",
            en: "Elegant Pink",
            jp: "ピンク",
            cn: "气质粉",
          },
          imageInfo: [
            {
              src: canvasEquipmentImage.wafers05,
              listSrc: equipmentImage.wafers05,
              width: 111,
              height: 112,
              x: 1083,
              y: 674,
              zIndex: 4,
            },
          ],
        },
        {
          id: 6,
          name: {
            zh: "愉悅橙",
            en: "Pleasant Orange",
            jp: "オレンジ",
            cn: "愉悦橙",
          },
          imageInfo: [
            {
              src: canvasEquipmentImage.wafers06,
              listSrc: equipmentImage.wafers06,
              width: 117,
              height: 125,
              x: 1080,
              y: 671,
              zIndex: 4,
            },
          ],
        },
      ],
    },
    // pets
    {
      categoryId: 6,
      title: { zh: "萌寵", en: "Pets", jp: "ペット", cn: "萌宠" },
      equipment: [
        // 總共6個
        {
          id: 1,
          name: { zh: "小眼仔", en: "Little Eye", jp: "つぶら", cn: "小眼仔" },
          imageInfo: [
            {
              src: canvasEquipmentImage.pets01,
              listSrc: equipmentImage.pets01,
              width: 236,
              height: 236,
              x: 1163,
              y: 762,
              zIndex: 4,
            },
          ],
        },
        {
          id: 2,
          name: { zh: "Ｑ寶", en: "Q-Bao", jp: "プリティ", cn: "Ｑ宝" },
          imageInfo: [
            {
              src: canvasEquipmentImage.pets02,
              listSrc: equipmentImage.pets02,
              width: 265,
              height: 265,
              x: 1149,
              y: 733,
              zIndex: 4,
            },
          ],
        },
        {
          id: 3,
          name: { zh: "阿瓦", en: "Awa", jp: "アワ", cn: "阿瓦" },
          imageInfo: [
            {
              src: canvasEquipmentImage.pets03,
              listSrc: equipmentImage.pets03,
              width: 341,
              height: 341,
              x: 1100,
              y: 723,
              zIndex: 4,
            },
          ],
        },
        {
          id: 4,
          name: { zh: "毛毛", en: "Fluffy", jp: "モフモフ", cn: "毛毛" },
          imageInfo: [
            {
              src: canvasEquipmentImage.pets04,
              listSrc: equipmentImage.pets04,
              width: 256,
              height: 256,
              x: 1112,
              y: 728,
              zIndex: 4,
            },
          ],
        },
        {
          id: 5,
          name: {
            zh: "蘑菇蘑菇",
            en: "Mushroom",
            jp: "モグモグ",
            cn: "蘑菇蘑菇",
          },
          imageInfo: [
            {
              src: canvasEquipmentImage.pets05,
              listSrc: equipmentImage.pets05,
              width: 301,
              height: 301,
              x: 1069,
              y: 728,
              zIndex: 4,
            },
          ],
        },
        {
          id: 6,
          name: { zh: "白啾", en: "ChuChu", jp: "バイチュウ", cn: "白啾" },
          imageInfo: [
            {
              src: canvasEquipmentImage.pets06,
              listSrc: equipmentImage.pets06,
              width: 394,
              height: 394,
              x: 1088,
              y: 376,
              zIndex: 4,
            },
          ],
        },
      ],
    },
    // background
    {
      categoryId: 7,
      title: { zh: "背景", en: "Background", jp: "背景", cn: "背景" },
      equipment: [
        // 總共5個
        {
          id: 1,
          name: {
            zh: "太空基地",
            en: "Space Base",
            jp: "宇宙ステーション",
            cn: "太空基地",
          },
          imageInfo: [
            {
              background: canvasEquipmentImage.background01,
              canvasBg: canvasEquipmentImage.canvasBg01,
              canvasBgSmall: canvasEquipmentImage.canvasBgSmall01,
            },
          ],
        },
        {
          id: 2,
          name: {
            zh: "奇異黑洞",
            en: "Strange Black Hole",
            jp: "不思議なブラックホール",
            cn: "奇异黑洞",
          },
          imageInfo: [
            {
              background: canvasEquipmentImage.background02,
              canvasBg: canvasEquipmentImage.canvasBg02,
              canvasBgSmall: canvasEquipmentImage.canvasBgSmall02,
            },
          ],
        },
        {
          id: 3,
          name: {
            zh: "耀眼銀河",
            en: "Dazzling Galaxy",
            jp: "まばゆい銀河",
            cn: "耀眼银河",
          },
          imageInfo: [
            {
              background: canvasEquipmentImage.background03,
              canvasBg: canvasEquipmentImage.canvasBg03,
              canvasBgSmall: canvasEquipmentImage.canvasBgSmall03,
            },
          ],
        },
        {
          id: 4,
          name: {
            zh: "月球表面",
            en: "Moon Surface",
            jp: "月面",
            cn: "月球表面",
          },
          imageInfo: [
            {
              background: canvasEquipmentImage.background04,
              canvasBg: canvasEquipmentImage.canvasBg04,
              canvasBgSmall: canvasEquipmentImage.canvasBgSmall04,
            },
          ],
        },
      ],
    },
  ],
  courseInfo: [
    {
      id: 1,
      name: {
        zh: "認識台積 GIW",
        en: "GIW in TSMC E-learning",
        jp: "TSMC GIW eラーニングカリキュラム",
        cn: "认识台积 GIW",
      },
    },
    {
      id: 2,
      name: {
        zh: "培養你的 GIW 能力-B.E.A.R",
        en: "BEAR E-learning",
        jp: "BEAR eラーニングカリキュラム",
        cn: "培养你的 GIW 能力-B.E.A.R",
      },
    },
    {
      id: 3,
      name: {
        zh: "多元、公平與共融宣言",
        en: "Diversity, Equity and Inclusion",
        jp: "多様性、公平性、包括性に関する宣言",
        cn: "多元、公平与共融宣言",
      },
    },
    {
      id: 4,
      name: {
        zh: "具備「成長心態」究竟是什麼意思？",
        en: 'What Having a "Growth Mindset" Actually Means?',
        jp: "成長思考を持つとはどういうことか？",
        cn: "具备「成长心态」究竟是什么意思？",
      },
    },
    {
      id: 5,
      name: {
        zh: "無意識的偏見",
        en: "Unconscious Bias",
        jp: "無意識の偏見",
        cn: "无意识的偏见",
      },
    },
    {
      id: 6,
      name: {
        zh: "什麼是心理安全感？",
        en: "What is Psycological Safety?",
        jp: "心理的安全性とは？",
        cn: "什么是心理安全感？",
      },
    },
    {
      id: 7,
      name: {
        zh: "打造多元共融的職場文化",
        en: "Creating a Diverse and Inclusive Workplace Culture",
        jp: "多様で包括的な職場文化の創造",
        cn: "打造多元共融的职场文化",
      },
    },
    // {
    //   id: 8,
    //   name: {
    //     zh: "Coming soon",
    //     en: "Coming soon",
    //     jp: "Coming soon",
    //     cn: "Coming soon",
    //   },
    // },
    // {
    //   id: 9,
    //   name: {
    //     zh: "Coming soon",
    //     en: "Coming soon",
    //     jp: "Coming soon",
    //     cn: "Coming soon",
    //   },
    // },
    {
      id: 10,
      name: {
        zh: "徹底坦率，讓溝通更有效！",
        en: "Communicate Effectively with Radical Candor",
        jp: "徹底した率直さ、コミュニケーションをより効果的にする",
        cn: "彻底坦率，让沟通更有效！",
      },
    },
    {
      id: 11,
      name: {
        zh: "Coming soon",
        en: "Coming soon",
        jp: "Coming soon",
        cn: "Coming soon",
      },
    },
  ],
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_INIT_START":
      return { ...state, loading: true, error: null };
    case "FETCH_INIT_SUCCESS":
      return { ...state, initData: action.payload, loading: false };
    case "FETCH_INIT_FAILURE":
      return { ...state, error: action.payload, loading: false };
    case "FETCH_STATUS_START":
      return { ...state, loading: true, error: null };
    case "FETCH_STATUS_SUCCESS":
      return { ...state, statusData: action.payload, loading: false };
    case "FETCH_STATUS_FAILURE":
      return { ...state, error: action.payload, loading: false };
    case "UPDATE_STATUS_START":
      return { ...state, loading: true, error: null };
    case "UPDATE_STATUS_SUCCESS":
      return { ...state, statusData: action.payload, loading: false };
    case "UPDATE_STATUS_FAILURE":
      return { ...state, error: action.payload, loading: false };
    case "UPDATE_NAME":
      return { ...state, userName: action.payload, loading: false };
    default:
      return state;
  }
};

export default userReducer;
